<ng-container *ngIf="{state: layout$ | async, context: context$ | async, crumbs: crumbs$ | async, available: available$ | async, influencer: isInfluencer$ | async, dark: isDarkTheme$ | async} as vm">
  <ng-container *ngIf="vm.state?.visible">

    <!-- The top menu: the navbar as it always looked, its items now from the server. -->
    <nav *ngIf="vm.state.topLayout; else bar" class="app-navbar new-styles navbar navbar-expand-md navbar-light bg-light sn-header"
         aria-label="Main">
      <div class="navbar-top-row">
        <a class="navbar-brand" routerLink="/projects" aria-label="Snöball home">
          <div class="logo-container" [class.logo-container--mark]="vm.context.inProjectContext">
            <img *ngIf="vm.context.inProjectContext" class="logo-mark" alt="Snöball" src="../assets/images/logo_mark_navbar.png">
            <ng-container *ngIf="!vm.context.inProjectContext">
              <img *ngIf="!vm.dark" alt="Snöball" src="../assets/images/logo_with_background_and_slogan_new.png">
              <img *ngIf="vm.dark" alt="Snöball" src="../assets/images/logo_with_background_and_slogan_new-transparent.png">
            </ng-container>
          </div>
        </a>
      </div>
      <div class="navbar-collapse navbar-mobile-panel sn-header__panel">
        <app-nav-top-menu *ngIf="vm.available; else unavailable">
          <li *ngIf="vm.context.inProjectContext" app-nav-project-switcher variant="navbar"
              class="nav-item dropdown projects-dropdown projects-links"></li>
        </app-nav-top-menu>
        <app-nav-toolbar [showSearch]="true" [showTasks]="!vm.influencer"></app-nav-toolbar>
        <div app-nav-user-menu variant="top" class="login-part dropdown"></div>
      </div>
    </nav>

    <!-- Beside the side menu, and on a phone: the breadcrumb in the menu's place. -->
    <ng-template #bar>
      <header class="app-navbar sn-header sn-header--bar">
        <a *ngIf="vm.state.presentation === 'drawer'" class="sn-header__mark" routerLink="/projects" aria-label="Snöball home">
          <img alt="" src="../assets/images/logo_mark_white.png" width="88" height="106">
        </a>
        <button *ngIf="vm.state.presentation === 'drawer'" type="button" class="sn-icon-button sn-header__hamburger"
                data-sn-hamburger aria-controls="sn-sidebar" [attr.aria-expanded]="vm.state.drawerOpen"
                aria-label="Open menu" (click)="openDrawer()">
          <i class="fa-solid fa-bars" aria-hidden="true"></i>
        </button>
        <app-nav-breadcrumb *ngIf="vm.available; else unavailable" [crumbs]="vm.crumbs"></app-nav-breadcrumb>
        <app-nav-toolbar [showSearch]="true" [showTasks]="!vm.influencer"></app-nav-toolbar>
        <div app-nav-user-menu variant="bar" class="sn-header__user dropdown"></div>
      </header>
    </ng-template>

    <ng-template #unavailable>
      <p class="sn-header__unavailable" role="status">
        Menu unavailable. <a href="" (click)="$event.preventDefault(); reload()">Reload</a>
      </p>
    </ng-template>
  </ng-container>
</ng-container>
